import { render, staticRenderFns } from "./TradeHeaderActions.vue?vue&type=template&id=02befaa1&scoped=true"
import script from "./TradeHeaderActions.vue?vue&type=script&lang=js"
export * from "./TradeHeaderActions.vue?vue&type=script&lang=js"
import style0 from "./TradeHeaderActions.vue?vue&type=style&index=0&id=02befaa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02befaa1",
  null
  
)

export default component.exports